import React, { useState } from 'react';
// Styles provided by RestaurantOnboarding.css

const PLANS = [
  {
    id: 1,
    exclusive: 1,
    label: 'Plan Exclusivo',
    badge: 'Mejor comisión',
    commission: '15%',
    tagline: 'Comprometido 100% con JAMA',
    color: 'orange',
    icon: '⭐',
    diff: 'Solo JAMA',
    diffSub: 'La comisión más baja disponible',
    benefits: [
      'Comisión reducida: solo 15%',
      'Mejor posicionamiento dentro de la app',
      'Mayor visibilidad en campañas',
      'Acceso prioritario a promociones',
      'Posibilidad de ser "Local Destacado"',
    ],
  },
  {
    id: 2,
    exclusive: 0,
    label: 'Plan Flexible',
    badge: 'Más libertad',
    commission: '20%',
    tagline: 'JAMA y todas las apps que quieras',
    color: 'blue',
    icon: '🌐',
    diff: 'Multi-plataforma',
    diffSub: 'Sin exclusividad de plataforma',
    benefits: [
      'Trabaja también en Rappi, Uber Eats y más',
      'Sin compromisos de exclusividad',
      'Acceso completo a JAMA',
      'Gestión de pedidos y pagos digitales',
      'Soporte técnico completo',
    ],
  },
];

const fmt = (n) => `$${n.toFixed(2)}`;

const PaymentInfo = ({ exclusive }) => {
  const plan      = PLANS.find((p) => p.exclusive === exclusive) ?? PLANS[0];
  const rate      = parseFloat(plan.commission) / 100;  // 0.135 | 0.185
  const sales     = 1000;
  const commission = sales * rate;
  const iva        = commission * 0.15;
  const platform   = 1.00;
  const receives   = sales - commission - iva - platform;
  return (
    <div className="ro-plan-payment">
      <ul className="ro-plan-payment-list">
        <li>Pagos <strong>semanales cada martes</strong> por las ventas de la semana anterior.</li>
        <li>Transferencia directa a tu cuenta bancaria registrada.</li>
        <li>Detalle de ventas y descuentos al correo registrado.</li>
        <li>Si el martes es feriado, el pago se realiza el siguiente día hábil.</li>
      </ul>

      {/* El key hace que los números animen al cambiar de plan */}
      <div className="ro-plan-example" key={plan.id}>
        <div className="ro-plan-example-title">
          Ejemplo — Plan {plan.label} (ventas de {fmt(sales)})
        </div>
        <div className="ro-plan-example-rows ro-plan-example-rows--anim">
          <div className="ro-plan-example-row">
            <span>Comisión {plan.commission}</span>
            <span>− {fmt(commission)}</span>
          </div>
          <div className="ro-plan-example-row">
            <span>IVA 15% sobre comisión</span>
            <span>− {fmt(iva)}</span>
          </div>
          <div className="ro-plan-example-row">
            <span>Costo fijo plataforma</span>
            <span>− {fmt(platform)}</span>
          </div>
          <div className="ro-plan-example-row ro-plan-example-row--total">
            <span>Tu recibo</span>
            <span>{fmt(receives)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const StepRestaurantPlan = ({ formData, onUpdate, errors = {} }) => {
  const [showPayment, setShowPayment] = useState(false);
  const selected = formData.exclusive; // 1 | 0 | null

  const handleSelect = (plan) => {
    onUpdate({ exclusive: plan.exclusive });
    setShowPayment(true);
  };

  return (
    <div className="ro-body ro-basic">

      <div className="ro-step-hd">
        <span className="ro-eyebrow ro-eyebrow--accent">Paso 7 · Plan</span>
        <h2 className="ro-title">Elige tu plan de comisión</h2>
        <p className="ro-subtitle">
          Selecciona cómo quieres trabajar con JAMA.<br />
          Puedes cambiar de plan en el futuro.
        </p>
      </div>

      {/* Plan cards */}
      <div className="ro-plan-cards">
        {PLANS.map((plan) => {
          const isSelected = selected === plan.exclusive;
          return (
            <button
              key={plan.id}
              type="button"
              className={`ro-plan-card ro-plan-card--${plan.color}${isSelected ? ' ro-plan-card--sel' : ''}`}
              onClick={() => handleSelect(plan)}
            >
              {plan.badge && (
                <span className="ro-plan-badge">{plan.badge}</span>
              )}

              <div className="ro-plan-card-top">
                <span className="ro-plan-icon">{plan.icon}</span>
                <div className="ro-plan-card-hd">
                  <span className="ro-plan-name">{plan.label}</span>
                  <span className="ro-plan-tagline">{plan.tagline}</span>
                </div>
              </div>

              {/* Chip de diferenciador */}
              <div className="ro-plan-diff">
                <span className="ro-plan-diff-key">{plan.diff}</span>
                <span className="ro-plan-diff-sub">{plan.diffSub}</span>
              </div>

              <div className="ro-plan-commission">
                <span className="ro-plan-pct">{plan.commission}</span>
                <span className="ro-plan-pct-lbl">de comisión sobre ventas</span>
              </div>

              <ul className="ro-plan-benefits">
                {plan.benefits.map((b, i) => (
                  <li key={i}>
                    <span className="ro-plan-check" aria-hidden="true">✓</span>
                    {b}
                  </li>
                ))}
              </ul>

              {isSelected && (
                <div className="ro-plan-selected-lbl">✔ Plan seleccionado</div>
              )}
            </button>
          );
        })}
      </div>

      {errors.exclusive && (
        <span className="ro-err-msg ro-err-msg--block">{errors.exclusive}</span>
      )}

      {/* Payment info toggle */}
      <button
        type="button"
        className="ro-plan-payment-toggle"
        onClick={() => setShowPayment((v) => !v)}
      >
        <span>💳 ¿Cómo y cuándo recibes tus pagos?</span>
        <span className={`ro-sch-panel-arr${showPayment ? ' ro-sch-panel-arr--up' : ''}`}>▾</span>
      </button>
      {showPayment && <PaymentInfo exclusive={selected} />}

    </div>
  );
};

export default StepRestaurantPlan;
